import { API_BASE_URL } from "./client";

function toQuery(params = {}) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;

    if (Array.isArray(value)) {
      if (value.length > 0) query.set(key, value.join(","));
      return;
    }

    query.set(key, String(value));
  });

  return query.toString();
}

export async function getPublicCatalog(params = {}, signal) {
  const query = toQuery(params);
  const response = await fetch(`${API_BASE_URL}/public/catalog${query ? `?${query}` : ""}`, {
    method: "GET",
    headers: { Accept: "application/json" },
    signal,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Catalogue request failed (${response.status}).`);
  }

  return response.json();
}

export function publicCoverUrl(coverImagePath) {
  const path = String(coverImagePath || "").trim();
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;

  const apiOrigin = String(API_BASE_URL || "").replace(/\/api\/?$/i, "");
  const clean = path
    .replace(/^Storage[\\/]/i, "")
    .replace(/^\/+/, "")
    .replace(/\\/g, "/");

  return `${apiOrigin}/storage/${clean}`;
}
